import React from "react"
//import I18n from "i18n-js/index.js.erb"
import RichTextEditor from "../RichTextEditor/RichTextEditor"
import clsx from "clsx"
import PageBuilderActions from "./actions/PageBuilderActions"
import PageBuilder from "./PageBuilder";


class Editor extends React.Component {

  constructor(props) {
    super(props);
    // this.mixins = [RandomMixin];
    // this.built = false;
    // this.changed = false;

    this.state = {
      initialized: false
    };

    this.onInit = this.onInit.bind(this);
    this.onSave = this.onSave.bind(this);
    // this._onStyleChange = this._onStyleChange.bind(this);
  };

  // mixins: [RandomMixin],

  render() {
    // console.log('render editor', this.props);
    var wrapperClasses = clsx({
      editorWrapper: true,
    });

    return (
      <div className={wrapperClasses}>
        <div>
          <RichTextEditor height={420 / 2} body={this.props.content} namespace={this.props.id} onInit={this.onInit} onChange={this.onSave} merge_tag_button={false} image_button={true} auto_resize={false} />
        </div>
      </div>
    );
  }  

  onInit() {
    PageBuilderActions.saveEditor(this.props.rowId, this.props.id, this.props.content);
    // this.setState({initialized: true});
  }

  onSave(content) {
    PageBuilderActions.saveEditor(this.props.rowId, this.props.id, content);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.forceUpdate === true || nextProps.openMenuRowId !== this.props.openMenuRowId) {
      return true;
    } else {
      return (nextProps.resizeRowId === nextProps.rowId) || (this.props.resizeRowId == this.props.rowId && nextProps.resizeRowId === null) || (nextProps.activeRowId === this.props.rowId && nextProps.activeColumnId === this.props.columnId) || (nextProps.mode !== this.props.mode)
    }
  }

};

export default Editor
